import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  GenerateBuyerActivitySummaryMutation,
  GenerateBuyerActivitySummaryMutationVariables,
} from "../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { updateBuyerActivityCache } from "./updateBuyerActivityCache";

const GENERATE_BUYER_ACTIVITY_MUTATION = graphql(`
  mutation generateBuyerActivitySummary(
    $GenerateBuyerActivitySummaryRequest: GenerateBuyerActivitySummaryRequest!
  ) {
    generateBuyerActivitySummary(
      GenerateBuyerActivitySummaryRequest: $GenerateBuyerActivitySummaryRequest
    ) {
      status
      updatedAt
      questions {
        question
        answer
        sources {
          type
          id
          url
          title
          chunkNumber
          documentType
          filePath
          isDeleted
          citationId
          locations {
            pageNumber
            bbox {
              x
              y
              width
              height
            }
          }
        }
      }
    }
  }
`);

export function useGenerateBuyerActivity(
  options?: UseMutationOptions<
    GenerateBuyerActivitySummaryMutation,
    unknown,
    GenerateBuyerActivitySummaryMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(GENERATE_BUYER_ACTIVITY_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await updateBuyerActivityCache(
        queryClient,
        variables.GenerateBuyerActivitySummaryRequest.objectId,
        variables.GenerateBuyerActivitySummaryRequest.objectType,
        data.generateBuyerActivitySummary,
      );
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      console.warn("Failed to generate buyer activity", JSON.stringify(error));
      options?.onError?.(error, variables, context);
    },
  });

  return { data, ...rest };
}
